import { Archive } from '@mui/icons-material'
import {
  Grid,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material'
import { useMemo } from 'react'
import { useLoadHandSignedProposals } from './useLoadHandSignedProposals'

type Props = {
  proposalId: string
}

export const HandSignedProposals = (props: Props) => {
  const { proposalId } = props
  const { data: handSignedProposals } = useLoadHandSignedProposals({
    proposalId
  })

  const handleItemClick = (item: string) => {
    window.open(item, '_blank')
  }

  const documents = useMemo(
    () => handSignedProposals?.data.flatMap((item) => item.attachments),
    [handSignedProposals?.data]
  )

  if (!handSignedProposals) return null

  return (
    <Grid item container xs={12}>
      {!!handSignedProposals?.data?.length && (
        <>
          <Grid item xs={12}>
            <Typography variant="h6">
              Documentos assinados enviados ao CIGAM
            </Typography>
          </Grid>

          <Grid item xs={12}>
            {documents?.map((item, index) => {
              return (
                <ListItem disablePadding key={item}>
                  <ListItemButton onClick={() => handleItemClick(item)}>
                    <ListItemIcon>
                      <Archive />
                    </ListItemIcon>
                    <ListItemText
                      primary={`Documento ${index + 1}`}
                      secondary="Clique para ver o documento!"
                    />
                  </ListItemButton>
                </ListItem>
              )
            })}
          </Grid>
        </>
      )}
    </Grid>
  )
}
